import api from '@/services/api'
import type {
  FundingRatesResponse,
  FundingRatesRequest,
  FundingRateGroupsRequest,
  FundingRateGroupsResponse,
  FundingRateSignalsResponse,
  FundingRateSignalRequest,
} from './types'

export const FundingRatesV2Service = {
  fetchFundingRates(page: number, filters: FundingRatesRequest) {
    return api.post<FundingRatesResponse>(`/v2/funding-rates/?page=${page}`, filters)
  },
  fetchFundingRateGroups(page: number, filters: FundingRateGroupsRequest) {
    return api.post<FundingRateGroupsResponse>(`/v2/funding-rates/groups/?page=${page}`, filters)
  },
  fetchFundingRateSignals(page: number, filters: FundingRateSignalRequest) {
    return api.post<FundingRateSignalsResponse>(`/v2/funding-rates/signals/?page=${page}`, filters)
  },
}
